"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.servicegraphql = exports.servicebasepath = exports.resposibilityservice = exports.releaseVersion = exports.recipeservice = exports.projectManagementSerivce = exports.programInnovation = exports.productbomManagement = exports.productManagement = exports.notification = exports.mcdService = exports.masterservice = exports.makebuyservice = exports.key = exports.itemservice = exports.itemPricing = exports.itemLogistics = exports.itemInventory = exports.gdeService = exports.formulaManagement = exports.entitlementservice = exports.custservice = exports.classservice = exports.catservice = exports.baseUrl = exports.artwork = exports.apolloGateway = exports.affiliateManagement = void 0;
exports.slashMerge = slashMerge;
exports.userservice = exports.todoservice = void 0;
const key = exports.key = "estee-lauder";
function slashMerge() {
  return Array.from(arguments).join("/");
}
const baseUrl = exports.baseUrl = slashMerge(key, "core");
/* export const servicebasepath = "http://10.252.33";
export const servicebasemap = "http://us-azr-dubip03";
//export const catservice = ".160/item_category";
//export const classservice = ".163/category_reference_data";
export const classservice = ":8082";
export const catservice = ":8089";
export const custservice = "";
export const itemservice = ".165/item_management";
export const masterservice = ".171/reference_data_management";
export const todoservice = ".169";
export const entitlementservice = ":8086/user_roles";
export const userservice = ":8088/user_management";
export const servicegraphql = "/graphql"; */

const servicebasepath = exports.servicebasepath = process.env.NODE_ENV === "production" ? "" : (window && window.localStorage.getItem("devDomain") || "https://cornerstone-dev.elcompanies.net") + "";
const releaseVersion = exports.releaseVersion = "R2";
const catservice = exports.catservice = "/item_category";
const classservice = exports.classservice = "/category_reference_data";
const custservice = exports.custservice = "";
const recipeservice = exports.recipeservice = "/recipe_management";
const itemservice = exports.itemservice = "/item_management";
const masterservice = exports.masterservice = "/reference_data_management";
const todoservice = exports.todoservice = "/todo";
const entitlementservice = exports.entitlementservice = "/entitlements";
const userservice = exports.userservice = "/user_management";
const makebuyservice = exports.makebuyservice = "/makebuy";
const itemInventory = exports.itemInventory = "/item_inventory";
const itemPricing = exports.itemPricing = "/item_pricing";
const productbomManagement = exports.productbomManagement = "/productbom_management";
const projectManagementSerivce = exports.projectManagementSerivce = "/project_management";
const resposibilityservice = exports.resposibilityservice = "/item_responsibility";
const servicegraphql = exports.servicegraphql = "/graphql";
const apolloGateway = exports.apolloGateway = "https://us-azr-dubip03:4000/graphql";
const programInnovation = exports.programInnovation = "/program_innovation";
const affiliateManagement = exports.affiliateManagement = "/affiliate_management";
const notification = exports.notification = "/notification";
const itemLogistics = exports.itemLogistics = "/logistics";
const gdeService = exports.gdeService = "/category_reference_data";
const mcdService = exports.mcdService = "/material_compatibility";
const formulaManagement = exports.formulaManagement = "/formula_management";
const productManagement = exports.productManagement = "/product_management";
const artwork = exports.artwork = "/artwork";